class TrieNode {
    constructor() {
        this.children = new Map();
        this.paramChild = null;
        this.paramName = null;
        this.wildcardChild = null;
        this.wildcardName = null;
        this.handlers = {};
    }
}

class RadixRouter {
    constructor() {
        this.root = new TrieNode();
        this.staticRoutes = new Map();
    }

    insert(method, path, routeConfig) {
        if (typeof path !== 'string') return;

        if (typeof routeConfig === 'function') {
            routeConfig = { handler: routeConfig };
        }

        let serializer = null;
        if (routeConfig.schema && routeConfig.schema.response) {
            try {
                const fastJson = require('fast-json-stringify');
                serializer = fastJson(routeConfig.schema.response);
            } catch (e) {
                console.error('[fullstx] Schema serializer compilation error:', e);
            }
        }

        const finalConfig = { ...routeConfig, serializer };

        if (!path.includes(':') && !path.includes('*')) {
            this.staticRoutes.set(method + path, finalConfig);
            return;
        }

        let current = this.root;
        const segments = path.split('/').filter(Boolean);

        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];

            if (segment.startsWith('*')) {
                if (!current.wildcardChild) {
                    current.wildcardChild = new TrieNode();
                    current.wildcardChild.wildcardName = segment.length > 1 ? segment.slice(1) : 'wildcard';
                }
                current = current.wildcardChild;

                break;
            } else if (segment.startsWith(':')) {
                if (!current.paramChild) {
                    current.paramChild = new TrieNode();
                    current.paramChild.paramName = segment.slice(1);
                }
                current = current.paramChild;
            } else {
                if (!current.children.has(segment)) {
                    current.children.set(segment, new TrieNode());
                }
                current = current.children.get(segment);
            }
        }
        current.handlers[method] = finalConfig;
    }

    lookup(method, path) {
        if (typeof path !== 'string') return null;

        const staticKey = method + path;
        if (this.staticRoutes.has(staticKey)) {
            const finalConfig = this.staticRoutes.get(staticKey);
            return { routeConfig: finalConfig, handler: finalConfig.handler, params: {} };
        }

        const segments = path.split('/').filter(Boolean);
        const params = {};

        let current = this.root;

        for (let i = 0; i < segments.length; i++) {
            const segment = segments[i];

            if (current.children.has(segment)) {
                current = current.children.get(segment);
            } else if (current.paramChild) {
                current = current.paramChild;
                params[current.paramName] = decodeURIComponent(segment);
            } else if (current.wildcardChild) {
                current = current.wildcardChild;
                params[current.wildcardName] = decodeURIComponent(segments.slice(i).join('/'));
                break;
            } else {
                return null;
            }
        }

        if (current.handlers[method]) {
            const finalConfig = current.handlers[method];
            return { routeConfig: finalConfig, handler: finalConfig.handler, params };
        }
        return null;
    }
}

module.exports = RadixRouter;
